/**
 * useConfig.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { useContext }    from 'react';
import { ConfigContext } from '~/contexts/config';

/**
 * Custom hook to access the configuration context.
 *
 * @returns The configuration object.
 */
export const useConfig = () => {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error('No configuration found in context');
  }

  return config;
}